export const headerData = [
  // {
  //   type: "checkbox",
  //   text: ""
  // },
  {
    text: "No.",
  },
  {
    text: "Date",
  },
  {
    text: "Store Name",
  },
  {
    text: "Total",
  },
  {
    text: "Channel",
  },
  {
    text: "",
  },
  {
    text: "",
  },
];

export const footerData = {
  title: "No record found",
  subTtitle: "No such order exists. Create one?",
  imgSrc: "../../../assets/images/no-search-icon.svg",
  alt: "no search found",
};

export const bodyDataAndKeyTypes = [
  // {
  //   key: "isChecked",
  //   type: "checkbox",
  // },
  {
    key: "orderNumber",
    type: "",
  },
  {
    key: "orderDate",
    type: "",
  },
  {
    key: "storeName",
    type: "",
  },
  {
    key: "orderTotal",
    type: "",
  },
  {
    key: "orderChannel",
    type: "",
  },
  {
    key: "orderStatus",
    type: "",
  },
  {
    key: "",
    type: "",
  },
];
